export default "__VITE_ASSET__DFjyYqrc__"